/**
 * Valores padrão das configurações da loja, como objeto simples.
 *
 * POR QUE ESTE ARQUIVO EXISTE, SEPARADO DO CONTRATO ZOD
 * -----------------------------------------------------
 * A vitrine precisa dos defaults na PRIMEIRA pintura (para o rodapé e o botão
 * de WhatsApp não aparecerem vazios enquanto `/api/configuracoes` responde).
 * Antes, o front obtinha isso com `esquemaConfiguracoes.parse({})` — o que
 * arrastava o **zod inteiro (18,5 KB gzip) para o bundle do visitante**, só
 * para ler constantes.
 *
 * Este módulo NÃO importa nada. O contrato zod, por sua vez, deriva os
 * `.default()` daqui — então continua havendo uma fonte de verdade única, e
 * quem só quer os valores não paga pelo validador.
 */
export const CONFIGURACOES_PADRAO = {
    // ── contato ──
    whatsappNumero: '5562981444890',
    whatsappMensagemPadrao: 'Olá, vim pelo site e gostaria de atendimento.',
    lojaTelefoneExibicao: '(62) 98144-4890',
    lojaEmail: '',
    lojaEndereco: 'R. Rio Verde - St. Campinas, Goiânia - GO, 74505-010',
    lojaMapsUrl: 'https://share.google/lFDxqeBKCNh8XeEV2',
    lojaHorario: 'Seg a Sex 8h às 18h · Sáb 8h às 13h',
    instagramUrl: 'https://instagram.com/empresabikepeniel',
    /** A loja não informou Facebook — vazio faz o rodapé OMITIR o item. */
    facebookUrl: '',
    // ── vitrine ──
    heroSelo: 'A sua nova aventura começa aqui',
    heroTitulo: 'Liberdade sobre duas rodas',
    /** Renderizado em brand-500, como o "duas rodas" do protótipo. */
    heroTituloDestaque: 'duas rodas',
    heroSubtitulo: 'Na Bicicletas Peniel você encontra as melhores opções em bicicletas novas e usadas, todas revisadas e com garantia de qualidade.',
    /** Chave da imagem no volume. Vazio = usa `/hero-fallback.webp`. */
    heroImagem: '',
    sobreTexto: 'Sua loja de bicicletas de confiança. Especialistas em vendas de modelos novos e seminovos totalmente revisados.',
    // ── seo ──
    seoTitulo: 'Bicicletas Peniel | Novas e Usadas',
    seoDescricao: 'Bicicletas novas e usadas revisadas em Goiânia. Fale com a gente pelo WhatsApp.',
};
//# sourceMappingURL=padroes-configuracao.js.map